
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mobiworkx/registration",
      function () {
        return require("private-next-pages/mobiworkx/registration.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mobiworkx/registration"])
      });
    }
  